import React, { Component } from "react";
import { Overlay, Popover } from "react-bootstrap";
import api from '../../apiClient/v1';
import * as css from "./ObservacionCliente.css";
import InputObservaciones from '../../components/shared/InputObservaciones.jsx'

class ObservacionCliente extends Component {
    constructor(props) {
        super(props)
        this.state = {
            show: false,
            observacion: this.props.observacion,
            editando: false,
        }
    }

    handleClick(e) {
        this.setState({
            target: e.target,
            show: !this.state.show
        });
    }

    handleClose() {
        this.setState({
            show: false
        });
    }

    cancelarEditar() {
        this.setState({
            editando: false,
            input: "",
        });
    }

    /*updateobservacion(observacion) {
        this.setState({
            observacion: observacion,
            tiene: observacion.length > 0 ? true : false
        })
    }*/

    /*traerLogistica(){
        this.setState({
            enableGet: false
        });
        api.logistica.getLogistica(this.props.idLocal)
        .then(resp => {
            this.setState({
                logistica: resp,
                enableGet: true,
            })
        })
        .catch(err => {
            console.log("Error al traer logistica")
        })
    }*/

    /*componentDidUpdate(prevProps) {
        if (prevProps.observacion !== this.props.observacion) {
            this.setState({
                observacion: this.props.observacion,
                tiene: true
            })
        }
    }*/

    render() {
        let styles = this.state.observacion !== 'Sin observaciones' ? { color: '#337AB7', cursor: 'pointer', verticalAlign: 'middle', alignContent: 'center', marginLeft: '2px' } : { color: '#5CB85C', verticalAlign: 'middle', alignContent: 'center', marginLeft: '2px' } ;
        return (
            <div style={this.state.show ? { backgroundColor: "#17b485" } : {}}>
                <p onClick={this.handleClick.bind(this)} style={styles}>
                    {this.state.observacion !== 'Sin observaciones' ? <i className="glyphicon glyphicon-info-sign" style={styles}></i> : <i className="glyphicon glyphicon-plus" style={styles}></i>}
                </p>
                <Overlay
                    show={this.state.show}
                    target={this.state.target}
                    placement="right"
                    onHide={this.handleClose.bind(this)}
                    rootClose
                >
                    <Popover
                        id={this.props.idAuditoria}
                        bsClass={css.observacion_popover + " popover"}
                    >
                        <InputObservaciones
                            ref={this.props.refer}
                            asignada={this.props.observacion}  // pide en string
                            onGuardar={this.props.onGuardar}
                            puedeModificar={this.props.puedeModificar} 
                        />
                    </Popover>
                </Overlay>
            </div>
        )
    }
}
export default ObservacionCliente;


// WEBPACK FOOTER //
// ./frontEnd/auditorias/programacion-semanal/ObservacionCliente.jsx